"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRentalServices = class UcRentalServices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    sortItems(...args) {
        return _.sortBy(args[0], p => (this.isServiceStale(p) ? "_" : "" + p.id));
    }
    isServiceStale(...args) {
        const [service] = args;
        return service.inactive ||
            (service.valid_to && this.$fn.parseISODate(service.valid_to) < this.today);
    }
    rental;
    onRental(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rental");
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    items;
    async $$load_items() {
        return this.rental
            ? this.$fn.fetch('list_rental_service', { parameters: { rental_id: this.rental.id } })
            : this.$fn.fetch('list_meter_rental_services', { parameters: { meter_id: this.meter.id } });
    }
    ux;
    dataMembers = ['items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
            },
        };
    }
    get assignToRental() {
        if (this.loaded) {
            return this.meter != null;
        }
        return null;
    }
    get preventEditMeter() {
        if (this.loaded) {
            return this.meter != null;
        }
        return null;
    }
    get preventEditRental() {
        if (this.loaded) {
            return this.rental != null;
        }
        return null;
    }
    async act_3343864469950044_emit_9582_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3343864469950044_close_9581_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_3343864469950044_showModal_9580_getActionArgs($event) {
        return {
            name: "RentalService",
            props: {
                rental: this.rental,
                meter: this.meter,
                assignToRental: this.assignToRental,
                preventEditMeter: this.preventEditMeter,
            },
        };
    }
    async evh_3343864469950044_clickPreventStop(event, scope) {
        return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3475726502813997_emit_9586_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3475726502813997_close_9585_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_3475726502813997_showModal_9584_getActionArgs($event) {
        return {
            name: "RentalService",
            props: {
                oid: $event.scope.item.id,
                mode: "edit",
                meter: this.meter,
                rental: this.rental,
                assignToRental: this.assignToRental,
                preventEditMeter: this.preventEditMeter,
                preventEditRental: this.preventEditRental,
            },
        };
    }
    async evh_3475726502813997_clickPreventStop(event, scope) {
        return await this.actions.evh_3475726502813997_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7286245325540822_showModal_9588_getActionArgs($event) {
        return {
            name: "RentalServiceCostAllocator",
            props: {
                service: $event.scope.item,
            },
        };
    }
    async evh_7286245325540822_clickPreventStop(event, scope) {
        return await this.actions.evh_7286245325540822_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_3343864469950044_emit_9582 = new core_1.actions.EmitAction({
            actionArgs: this.act_3343864469950044_emit_9582_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_close_9581 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_emit_9582,
            event: "close",
            when: this.evh_3343864469950044_close_9581_getWhen,
            displayName: "emit",
        });
        const act_3343864469950044_showModal_9580 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3343864469950044_showModal_9580_getActionArgs,
            events: [evh_3343864469950044_close_9581],
        });
        const evh_3343864469950044_clickPreventStop_9579 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_showModal_9580,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_3343864469950044_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_clickPreventStop_9579],
        });
        const act_3475726502813997_emit_9586 = new core_1.actions.EmitAction({
            actionArgs: this.act_3475726502813997_emit_9586_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_3475726502813997_close_9585 = new core_1.actions.EventHandlerImpl({
            action: act_3475726502813997_emit_9586,
            event: "close",
            when: this.evh_3475726502813997_close_9585_getWhen,
            displayName: "emitReload",
        });
        const act_3475726502813997_showModal_9584 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3475726502813997_showModal_9584_getActionArgs,
            events: [evh_3475726502813997_close_9585],
        });
        const evh_3475726502813997_clickPreventStop_9583 = new core_1.actions.EventHandlerImpl({
            action: act_3475726502813997_showModal_9584,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_3475726502813997_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3475726502813997_clickPreventStop_9583],
        });
        const act_7286245325540822_showModal_9588 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7286245325540822_showModal_9588_getActionArgs,
            events: [],
        });
        const evh_7286245325540822_clickPreventStop_9587 = new core_1.actions.EventHandlerImpl({
            action: act_7286245325540822_showModal_9588,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7286245325540822_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7286245325540822_clickPreventStop_9587],
        });
        return {
            act_3343864469950044_emit_9582,
            evh_3343864469950044_close_9581,
            act_3343864469950044_showModal_9580,
            evh_3343864469950044_clickPreventStop_9579,
            evh_3343864469950044_clickPreventStop,
            act_3475726502813997_emit_9586,
            evh_3475726502813997_close_9585,
            act_3475726502813997_showModal_9584,
            evh_3475726502813997_clickPreventStop_9583,
            evh_3475726502813997_clickPreventStop,
            act_7286245325540822_showModal_9588,
            evh_7286245325540822_clickPreventStop_9587,
            evh_7286245325540822_clickPreventStop,
            emitReload: act_3475726502813997_emit_9586,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcRentalServices.prototype, "rental", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rental'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalServices.prototype, "onRental", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcRentalServices.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalServices.prototype, "onMeter", null);
UcRentalServices = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRentalServices);
exports.default = UcRentalServices;
vue_property_decorator_1.Vue.component("UcRentalServices", UcRentalServices);
